<h2 mat-dialog-title>
  {{ 'CRM_FIELDS_DIALOG.TITLE' | translate }}
</h2>
<mat-dialog-content>
  <automata-automation-replacement-chips
    [label]="label | translate"
    [dataService]="selectorService"
    [formControl]="formControl"
    [isRequired]="true"
    [multiple]="true"
    [supportDataPassing]="false"
    [extraData]="{
      supportedFieldTypes: supportedFieldTypes,
      crmObjectType: crmObjectType,
      fieldOverrides: fieldOverrides,
    }"
  ></automata-automation-replacement-chips>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="primary" mat-dialog-close tabindex="2">
    {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button mat-raised-button color="primary" tabindex="1" (click)="save()">
    {{ 'COMMON.ACTION_LABELS.SAVE' | translate }}
  </button>
</mat-dialog-actions>
